"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cptRiskCategoryDictionaryResponse = exports.cptRiskCategoryRowValues = void 0;
exports.cptRiskCategoryRowValues = [
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "3, 4, 5",
        CATEGORY: "CORRECT",
        ASSESSMENT: "IDEAL CPT"
    },
    {
        ROLE: "NON-PAYABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "4,5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "CPT IS NON-PAYABLE FOR FFS"
    },
    {
        ROLE: "TRACKING",
        "ACCEPTABILITY\nBY STAR USE CASE": "4,5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "CPT IS USED FOR TRACKING PURPOSES AND IS NOT CODABLE"
    },
    {
        ROLE: "PERFORMED",
        "ACCEPTABILITY\nBY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "UNBUNDLED (SEPARATE PROCEDURE, CCI EDIT, ETC.)"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "INVALID PRIMARY (E.G., ADD ON CODE)"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "MISSING OR INVALID ATTESTATION"
    },
    {
        ROLE: "PERFORMED",
        "ACCEPTABILITY\nBY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "SPLIT/SHARED SERVICE NON-BILLABLE PROVIDER"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "WRONG E/M CATEGORY OR CPT SPECIFICITY (INITIAL VS SUBSEQUENT, INPATIENT VS. CRITICAL CARE)(CORRECT CATEGORY)"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "OVERCODED 1 E/M OR CPT LEVEL (E.G., 8830X)"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "UNDERCODED 1  E/M LEVEL OR CPT LEVEL"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "OVERCODED 2 E/M LEVELS OR CPT LEVEL"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "UNDERCODED 2 E/M LEVELS OR CPT LEVEL"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "NOT DOCUMENTED"
    },
    {
        ROLE: "MACRA/MIPS",
        "ACCEPTABILITY\nBY STAR USE CASE": "3",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "REQUIREMENTS NOT DOCUMENTED/MET"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "NO",
        CATEGORY: "MISSED",
        ASSESSMENT: "CPT/EM CODE"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "NO",
        CATEGORY: "MISSED",
        ASSESSMENT: "ADDITIONAL UNIT OF CODED CPT"
    },
    {
        ROLE: "CODABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "NO",
        CATEGORY: "MISSED",
        ASSESSMENT: "CORRECT E/M LEVEL OR CPT LEVEL (WRONG LEVEL CODED)"
    },
    {
        ROLE: "NON-PAYABLE",
        "ACCEPTABILITY\nBY STAR USE CASE": "3",
        CATEGORY: "MISSED",
        ASSESSMENT: "NON-PAYABLE CPT/EM CODE (POST-OP E/M)"
    },
    {
        ROLE: "TRACKING",
        "ACCEPTABILITY\nBY STAR USE CASE": "3",
        CATEGORY: "MISSED",
        ASSESSMENT: "TRACKING CPT/EM CODE"
    },
    {
        ROLE: "MACRA/MIPS",
        "ACCEPTABILITY\nBY STAR USE CASE": "3",
        CATEGORY: "MISSED",
        ASSESSMENT: "DOCUMENTED MACRA/MIPS CODE"
    },
    {
        ROLE: "PERFORMED",
        "ACCEPTABILITY\nBY STAR USE CASE": "3, 4",
        CATEGORY: "MISSED",
        ASSESSMENT: "PERFORMED CPT"
    },
    {
        ROLE: "HISTORIC",
        "ACCEPTABILITY\nBY STAR USE CASE": "3, 4",
        CATEGORY: "MISSED",
        ASSESSMENT: "CPT/EM IS DOCUMENTED AS A PAST ENCOUNTER"
    },
    {
        ROLE: "RECOMMENDED",
        "ACCEPTABILITY\nBY STAR USE CASE": "3, 4",
        CATEGORY: "MISSED",
        ASSESSMENT: "CPT/EM IS DOCUMENTED AS A FUTURE ENCOUNTER OR RECOMMENDED ENCOUNTER"
    },
    {
        ROLE: "ALTERNATE CODE",
        "ACCEPTABILITY\nBY STAR USE CASE": "3, 4",
        CATEGORY: "MISSED",
        ASSESSMENT: "CPT/EM HAS AN ALTERNATE CODE (HCPCS)"
    }
];
exports.cptRiskCategoryDictionaryResponse = {
    numRows: 24,
    columnNames: [
        "CATEGORY",
        "ASSESSMENT",
        "ROLE",
        "ACCEPTABILITY\nBY STAR USE CASE"
    ],
    rowValues: exports.cptRiskCategoryRowValues
};
//# sourceMappingURL=cpt-risk-categories.js.map